import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor - Attach token to requests
axiosInstance.interceptors.request.use(
    (config) => {
        const kiosk_token = localStorage.getItem('kiosk_token');
        if (kiosk_token) {
            const cleanToken = kiosk_token.replace(/^"(.*)"$/, '$1');
            config.headers.Authorization = `Bearer ${cleanToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default axiosInstance;